import(/* webpackMode: "eager" */ "/home/runner/work/dreamconnect/dreamconnect/app/global-error.tsx");
